export enum Brand {
  AdventureIsland = 'adventure-island',
  Aquatica = 'aquatica',
  BuschGardens = 'busch-gardens',
  DiscoveryCove = 'discovery-cove',
  SeaWorld = 'seaworld',
  SesamePlace = 'sesame-place',
  WaterCountry = 'water-country',
}
